// ********************************* Package Imports *********************************
import React from "react";
import TextIconInput from "../custom-fields/input";
import { CustomButton } from "../buttons/button";

// ********************************* Icon Imports *********************************
import { AiOutlinePlus } from "react-icons/ai";
import SearchIcon from "../../assets/icons/search-icon.svg";
import { HiOutlineInformationCircle } from "react-icons/hi2";
import Tooltip from "../tooltip";

interface Props {
  heading: string;
  description: string;
  note?:string;
  totalCount?:string|number;
  countForText?:string;
  setShowSearch?: (value: string) => void;
  handleSearch?: (value: string) => void;
  showSearch?: string;
  onclickAddButton?: (value: boolean) => void;
  search?: boolean;
  addNew?: boolean;
  options?:any;
  handleSelect?:any;
  searchDropdown?:any;
  showValue?:any;
  customClass?:string
}

const Index: React.FC<Props> = ({
  setShowSearch,
  handleSearch,
  showSearch,
  heading,
  description,
  note,
  totalCount,
  countForText,
  search,
  addNew,
  onclickAddButton,
  options,
  handleSelect,
  searchDropdown,
  showValue,
  customClass
}) => {
  return (
    <div className={customClass?customClass:"card bg-[#025963] p-[12px] rounded-[8px] mb-[18px]"}>
      <div className="grid w-full min-w-0 grid-cols-1 items-start gap-3 md:grid-cols-[minmax(0,1fr)_auto] md:items-center md:gap-4">
        <div className="min-w-0 pr-0">
          <div className="flex items-center">
            <h2 className="text-[#FFF] text-[16px] font-semibold">{heading}</h2>
            {note ? <Tooltip content={note} position="right" contentClass="min-w-[400px]" >
            <HiOutlineInformationCircle size={18} className="text-[#FFF] ml-[8px]"  />
            </Tooltip> : null}
          </div>
          <p className="text-[#CACDCD] text-[12px] mt-0.5 leading-snug">{description}</p>
        </div>
        <div className="flex w-full min-w-0 flex-col items-end gap-2 sm:w-auto sm:flex-row sm:flex-wrap sm:items-center sm:justify-end sm:gap-x-3 sm:gap-y-2 md:justify-self-end">
          {(totalCount || totalCount === 0) && countForText ? (
            <p className="shrink-0 text-right text-[#CACDCD] text-[16px] font-medium flex items-center justify-end whitespace-nowrap sm:border-r sm:border-white/30 sm:pr-3 sm:text-left md:pr-4">
              {totalCount} {countForText}
            </p>
          ) : null}
          {search ? (
            <TextIconInput
              placeholder="Search"
              divStyle="w-full max-w-[320px] sm:w-[280px] min-w-0"
              onChange={(e: any) => {
                if (setShowSearch) setShowSearch(e.target.value);
              }}
              inputStyle="w-full rounded-[8px] pr-[35px] "
              icon={SearchIcon}
              value={showSearch}
              setShowSearch={setShowSearch}
              clearSearch={handleSearch}
              iconStyle="w-[18px] h-[18px] top-[12px] right-[10px]"
            />
          ) : null}
          {addNew ? (
            <CustomButton
              buttonName="Add new"
              primary={true}
              buttonStyle="text-white shrink-0 text-[14px] p-[12px] font-semibold leading-[17px] border-none"
              isFront
              onClick={onclickAddButton}
              icon={<AiOutlinePlus size={18} />}
              iconStyle="mr-[8px] font-semibold"
            />
          ) : null}
          {searchDropdown ? (
          <div className="flex gap-[10px] w-full sm:w-auto">
              <div className="flex items-center border-[transparent] rounded-lg overflow-hidden">
                <select
                  name="facility"
                  className="cursor-pointer bg-gray-50 py-[11.5px] text-gray-900 text-sm border-gray-50 focus:ring-blue-500 focus:border-blue-500 p-2.5  rounded-l-lg focus:outline-none w-[150px]"
                  onChange={(e) => handleSelect(e)}
                >
                  <option value="all" selected className="text-[11px]">
                    All
                  </option>
                  {options?.length > 0 && (
                    <>
                      {options?.map((item: any, index: number) => (
                        <option
                          key={index}
                          value={item?.id}
                          className="text-[11px]"
                        >
                          {showValue ? item[`${showValue}`] : item}
                        </option>
                      ))}
                    </>
                  )}
                </select>
                <TextIconInput
                  placeholder="Search"
                  divStyle="max-w-[200px] rounded-[0px]"
                  onChange={(e: any) => {
                   if (setShowSearch) setShowSearch(e.target.value);
                  }}
                  inputStyle="w-full !rounded-l-[0px] pr-[35px] border-0 rounded-[0px]"
                  icon={SearchIcon}
                  value={showSearch}
                  setShowSearch={setShowSearch}
                  clearSearch={()=>{
                    if (setShowSearch) setShowSearch('');
                  }}
                  iconStyle="w-[18px] h-[18px] top-[12px] right-[10px] border-none rounded-[0px]"
                />
              </div>
            </div>
            ):null}
        </div>
      </div>
    </div>
  );
};

export default Index;
